/* Component Dependencies */
var rewardsCategoryInfoTemplate = require('templates/rewardsCategoryInfo.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'rewardsCategoryInfo',
  template: {
    'rewardsCategoryInfo': rewardsCategoryInfoTemplate
  },
  bindEvents: function() {
    var _self = this;
    _self.registerPopup();
  },
  /**
  * This function registers Popup for the points needed per night anchor
  */
 registerPopup: function() {
     var _self= this;
     var marriottRewardsPointsPopup = new Popup({
         selector: '.js-open-popup',
         sourceBlock: '.modal-content',
         alternateCloseMarkup: true
     });
     marriottRewardsPointsPopup.register();
 }
});
